import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Footer } from "../organisms/footer";
import { Header } from "../organisms/header";
import { FormHeader } from "../atoms/formHeader/FormHeader";
import { BreadCrumbs } from "../molecules/BreadCrumbs/BreadCrumbs";
import { CookieBanner } from "../molecules/CookieBanner/CookieBanner";
import { FunctionComponent, ReactNode, useEffect } from "react";
import { RoutesList } from "../../routes/Routes";
import { useWasteStore } from "../../store/store";
import { isValidWasteCategoryAndRoute } from "@utils/isValidWasteCategoryAndRoute";
import { ScrollToTop } from "..";
import { GovMetricSidebar } from "@components/molecules/GovMetricSidebar/GovMetricSidebar";


type Props = {
  children?: ReactNode;
};

export const Layout: FunctionComponent<Props> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { wasteCategory } = useWasteStore();

  const routesList = [
    RoutesList.YOUR_DETAILS,
    RoutesList.WASTE_DETAILS,
    RoutesList.UPLOAD_PHOTO,
  ];
  const isBeforeYouStart = location.pathname === RoutesList.WASTE_HOME;
  const isWastePath = location.pathname.includes("/waste");
  const isConfirmationPath = location.pathname.includes("/confirmation");

  const formHeaderTitle =
    !isBeforeYouStart && !isConfirmationPath
      ? isWastePath
        ? "Report a Waste problem"
        : undefined
      : undefined;

  // Monitors the waste category and pathname to ensure correct category is selected from landing page
  useEffect(() => {
    if (!isValidWasteCategoryAndRoute(wasteCategory, location.pathname)) {
      navigate(RoutesList.NOT_FOUND);
    }
  }, [wasteCategory, location.pathname]);

  return (
    <main className="grid h-full min-h-screen grid-rows-[auto_1fr_auto] overflow-hidden overflow-x-hidden bg-white">
      <CookieBanner />
      <GovMetricSidebar />
      <Header />
      <section
        id="main-content-heading"
        className="px-6 md:px-10 lg:px-16 xl:px-[12.5%]"
      >
        {isBeforeYouStart ? (
          <FormHeader title="How do you want to report this issue?" />
        ) : (
          <FormHeader title={formHeaderTitle} />
        )}
        {routesList.includes(location.pathname) && (
          <BreadCrumbs pathname={location.pathname} />
        )}
        <ScrollToTop />
        <Outlet />
      </section>
      <section
        id="main-content"
        className="h-full overflow-hidden overflow-x-hidden px-6 pb-20 md:px-10 lg:px-16 xl:px-[12.5%]"
      >
        {props.children}
      </section>
      <Footer />
    </main>
  );
};

export default Layout;
